module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "float": "none"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v(_vm._s(_vm.srMediaType.name))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.scannedReportMediaList,
      "columns": _vm.srGridSpec.columns,
      "options": _vm.srGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "download",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-cloud-download",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.mediaDownloadRow(props.row.mediaId, props.row.mediaTypeId, props.row.mediaSubtype, props.row.parentId, props.row.filename)
            }
          }
        })])]
      }
    }, {
      key: "remove",
      fn: function(props) {
        return _vm.isShpo ? [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.mediaRemove(props.row.mediaId)
            }
          }
        })])] : undefined
      }
    }])
  })], 1)]), _vm._v(" "), _vm._l((_vm.docMediaTypes), function(mediaType) {
    return _c('div', {
      key: mediaType.mediaTypeId,
      staticClass: "form-group",
      attrs: {
        "value": mediaType.mediaTypeId
      }
    }, [_c('label', {
      staticClass: "col-md-2 control-label text-label"
    }, [_vm._v(_vm._s(mediaType.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('v-client-table', {
      attrs: {
        "data": _vm.gridSpec.tableData.filter(function (x) {
          return x.mediaTypeId === mediaType.mediaTypeId
        }),
        "columns": _vm.gridSpec.columns,
        "options": _vm.gridSpec.options
      },
      scopedSlots: _vm._u([{
        key: "download",
        fn: function(props) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center"
            }
          }, [_c('a', {
            staticClass: "fa fa-cloud-download",
            staticStyle: {
              "font-size": "18px"
            },
            on: {
              "click": function($event) {
                _vm.mediaDownloadRow(props.row.mediaId, props.row.mediaTypeId, props.row.mediaSubtype, props.row.parentId, props.row.filename)
              }
            }
          })])]
        }
      }, {
        key: "recording",
        fn: function(props) {
          return [(props.row.crrId !== _vm.prodCrrId) ? _c('div', {
            staticStyle: {
              "text-align": "center"
            }
          }, [_c('a', {
            on: {
              "click": function($event) {
                _vm.viewRecording(props.row.crrId)
              }
            }
          }, [_vm._v(_vm._s(props.row.crrId))])]) : _vm._e()]
        }
      }, {
        key: "remove",
        fn: function(props) {
          return _vm.isShpo && props.row.crrId === _vm.prodCrrId ? [_c('div', {
            staticStyle: {
              "text-align": "center"
            }
          }, [_c('a', {
            staticClass: "fa fa-ban",
            staticStyle: {
              "font-size": "18px"
            },
            on: {
              "click": function($event) {
                _vm.mediaRemove(props.row.mediaId)
              }
            }
          })])] : undefined
        }
      }])
    })], 1)])
  }), _vm._v(" "), (_vm.isShpo) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Add File")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('fieldset', [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "mediaForm",
      "data-vv-scope": "mediaFile"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mediaFile.mediaTypeId')
    }
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMediaTypeId),
      expression: "selectedMediaTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mediaTypeId",
      "data-vv-validate-on": "none"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedMediaTypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.srMediaType.mediaTypeId
    }
  }, [_vm._v("\n                                        Scanned Document\n                                    ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.docMediaTypes[0].mediaTypeId
    }
  }, [_vm._v("\n                                        Image\n                                    ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.docMediaTypes[1].mediaTypeId
    }
  }, [_vm._v("\n                                        Laboratory Result\n                                    ")])]), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mediaFile.mediaTypeId')),
      expression: "errors.has('mediaFile.mediaTypeId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("File type is required")])])])]), _vm._v(" "), (_vm.selectedMediaTypeId === 7) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mediaFile.mediaSubtypeId')
    }
  }, [_c('label', [_vm._v("Subtype")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mediaSubtypeId),
      expression: "mediaSubtypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mediaSubtypeId",
      "data-vv-validate-on": "none"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mediaSubtypeId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.labResultsSubtypes), function(subtypes) {
    return _c('option', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedMediaTypeId === 7),
        expression: "selectedMediaTypeId === 7"
      }],
      key: subtypes.mediaSubtypeId,
      domProps: {
        "value": subtypes.mediaSubtypeId
      }
    }, [_vm._v("\n                                        " + _vm._s(subtypes.name) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mediaFile.mediaSubtypeId')),
      expression: "errors.has('mediaFile.mediaSubtypeId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Subtype is required")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mediaFile.newFile')
    }
  }, [_c('label', [_vm._v("File")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "newFile",
    staticClass: "file",
    attrs: {
      "name": "newFile",
      "type": "file",
      "data-vv-validate-on": "none"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mediaFile.newFile')),
      expression: "errors.has('mediaFile.newFile')"
    }],
    staticClass: "has-error"
  }, [_vm._v("File is required")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('mediaFile.comment')
    }
  }, [_c('label', [_vm._v("Comment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "comment",
      "type": "text",
      "data-vv-validate-on": "none"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mediaFile.comment')),
      expression: "errors.has('mediaFile.comment')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Comment is required")])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-1",
    on: {
      "click": _vm.addFile
    }
  }, [_vm._v("Upload")])])])])]) : _vm._e(), _vm._v(" "), _vm._m(0)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27c7986e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteProduction/SiteDocuments.vue
// module id = 913
// module chunks = 1